import React from "react";
import { compose } from "helper/compose";
import { Link } from "react-router-dom";
import { withTranslation, type WithTranslation } from "react-i18next";

import BlockedAccountForm from "./BlockedAccountForm";
import RichText from "../Common/RichText";
import { withContentData, type ContentQueryProps } from "api/queries/useContent";
import { withAuthData, type AuthInjectedProps } from "../../context/AuthContext";

const BlockedAccountFormAny = BlockedAccountForm as unknown as React.ComponentType<
  Record<string, unknown>
>;

interface FormErrorItem {
  code: string;
  message: string;
}

interface BlockedAccountPageOwnProps extends WithTranslation {}

type BlockedAccountPageProps = BlockedAccountPageOwnProps & ContentQueryProps & AuthInjectedProps;

const RESET_PASSWORD_TEXT = "password_reset_text";

function BlockedAccountPage({
  t,
  contents,
  contentsLoaded,
  actions,
  resetPasswordPageMessage,
}: BlockedAccountPageProps) {
  const [formData, setFormData] = React.useState<{ email: string }>({ email: "" });
  const [formError, setFormError] = React.useState<FormErrorItem[] | undefined>(undefined);

  const onFormChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const field = event.target.name as "email";
    const value = event.target.value;
    setFormData((prev) => ({ ...prev, [field]: value }));
  };

  const onFormSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();

    actions.removeResetPasswordMessage();

    const errors: FormErrorItem[] = [];
    if (formData.email === "") {
      errors.push({
        code: "MAIL",
        message: t("blocked_account.error_submit"),
      });
    }

    setFormError(errors);

    if (errors.length === 0) {
      actions.resetPassword(formData.email);
    }
  };

  const content = contents[RESET_PASSWORD_TEXT];

  return (
    <div className="Page">
      <div className="Page-content">
        <div className="LogoCompanyWrapper">
          <Link to={BASE_PATH + "/"}>
            <div className="LogoCompany isSpaced isGMC"></div>
          </Link>
        </div>
        {contentsLoaded && content && content.content ? (
          <section className="DashboardBlock">
            <RichText className="ContentPage-text" html={content.content} />
          </section>
        ) : null}
        <h2 className="Page-title isSpaced">{t("blocked_account.title")}</h2>
        <BlockedAccountFormAny
          onChange={onFormChange}
          onSubmit={onFormSubmit}
          formError={formError}
          message={resetPasswordPageMessage}
        />
      </div>
    </div>
  );
}

export default compose(withTranslation(), withAuthData, withContentData)(BlockedAccountPage);
